import img20a from '../../../assets/gallery/20b/20b-01-HOME_ST-2020-426x464mm-oleo-sobre-madera.jpg';
import img20b from '../../../assets/gallery/20b/20b-02_ST-2020-345x43mm-oleo-sobre-madera.jpg';
import img20c from '../../../assets/gallery/20b/20b-03_ST-2020-435x510mm-oleo-sobre-madera.jpg';
import img20d from '../../../assets/gallery/20b/20b-04_ST-2020-325x427mm-oleo-sobre-madera.png';
import img20e from '../../../assets/gallery/20b/20b-05_ST-2020-44x44cm-oleo-sobre-madera.jpg';
import img20f from '../../../assets/gallery/20b/20b-06_ST-2020-455x526mm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "42,6 x 46,4 cm",
    pictureSrc: img20a,
    description: "2020",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "34,5 x 43 cm",
    pictureSrc: img20b,
    description: "2020",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "43,5 x 51 cm",
    pictureSrc: img20c,
    description: "2020",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "32,5 x 42,7 cm",
    pictureSrc: img20d,
    description: "2020",
    orientation: "h"
  },
  {
    id: 5,
    title: "",
    dimensions: "44 x 44 cm",
    pictureSrc: img20e,
    description: "2020",
    orientation: "h"
  },
  {
    id: 6,
    title: "",
    dimensions: "45,5 x 52,6 cm",
    pictureSrc: img20f,
    description: "2020",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/20b/data20b.js